/**
 * Custom Product Landing - JS
 * Handles: URL param overrides, carousel, variant selection,
 * selling plan toggle, AJAX cart, FAQs, dynamic pricing
 */

(function () {
  'use strict';

  // Layout presets: each layout maps to a set of param defaults
  var LAYOUT_PRESETS = {
    v1: { recipe: 'images', size: 'pills', purchase: 'toggle', cta_color: 'orange', benefits: 'list' },
    v2: { recipe: 'none',   size: 'none',  purchase: 'toggle', cta_color: 'orange', benefits: 'list' },
    v3: { recipe: 'text',   size: 'pills', purchase: 'subscribe', cta_color: 'orange', benefits: 'grid' },
    v4: { recipe: 'text',   size: 'cards', purchase: 'subscribe_link', cta_color: 'orange', benefits: 'list' },
  };

  var PARAM_KEYS = ['recipe', 'size', 'purchase', 'cta_color', 'benefits'];

  document.querySelectorAll('.cpl').forEach(initSection);

  function initSection(section) {
    var sectionId = section.dataset.sectionId;
    var productData = JSON.parse(section.querySelector('[data-cpl-product-json]').textContent);
    var badgesData = JSON.parse(section.querySelector('[data-cpl-badges-json]').textContent).filter(Boolean);
    var variants = productData.variants;
    var moneyFormat = productData.money_format;
    var adminLayout = productData.admin_layout || 'v1';

    var currentVariant = variants.find(function (v) { return v.available; }) || variants[0];
    var purchaseType = 'subscribe';
    var sellingPlanGroups = productData.selling_plan_groups;
    var hasSellingPlans = sellingPlanGroups && sellingPlanGroups.length > 0;
    var defaultSellingPlanId = productData.default_selling_plan_id || null;

    // Selected option values by position (1-indexed)
    var selectedOptions = {};
    productData.options.forEach(function (optName, i) {
      selectedOptions[i + 1] = currentVariant.options[i];
    });

    // =========================================
    // URL PARAMETER OVERRIDES
    // =========================================
    applyUrlParams();

    function applyUrlParams() {
      var params = new URLSearchParams(window.location.search);
      var layoutParam = params.get('layout');

      // If a layout param is present, apply its preset first
      if (layoutParam && LAYOUT_PRESETS[layoutParam]) {
        var preset = LAYOUT_PRESETS[layoutParam];
        section.dataset.layout = layoutParam;
        PARAM_KEYS.forEach(function (key) {
          section.dataset[camelCase(key)] = preset[key];
        });
      }

      // Then apply any individual param overrides
      PARAM_KEYS.forEach(function (key) {
        var val = params.get(key);
        if (val) {
          section.dataset[camelCase(key)] = val;
        }
      });

      // Update CTA text based on resolved purchase mode
      updateCtaText();
    }

    function camelCase(str) {
      return str.replace(/_([a-z])/g, function (m, c) { return c.toUpperCase(); });
    }

    function getParam(key) {
      return section.dataset[camelCase(key)] || '';
    }

    function updateCtaText() {
      var purchaseMode = getParam('purchase');
      var textEl = section.querySelector('[data-atc-text]');
      if (!textEl) return;

      if (purchaseMode === 'subscribe' || purchaseMode === 'subscribe_link') {
        textEl.textContent = 'SUBSCRIBE';
        purchaseType = 'subscribe';
      } else {
        textEl.textContent = 'ADD TO CART';
        // Default to subscribe if has selling plans
        purchaseType = hasSellingPlans ? 'subscribe' : 'onetime';
      }
    }

    // =========================================
    // CAROUSEL
    // =========================================
    var mainImages = section.querySelectorAll('.cpl__main-image');
    var thumbnails = section.querySelectorAll('.cpl__thumbnail');
    var prevArrow = section.querySelector('.cpl__thumb-arrow--prev');
    var nextArrow = section.querySelector('.cpl__thumb-arrow--next');
    var currentImageIndex = 0;

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function showImage(index, userInitiated) {
      if (index < 0 || index >= mainImages.length) return;
      currentImageIndex = index;

      if (isMobile()) {
        // On mobile: scroll the horizontal carousel to the image
        // Only scroll the carousel strip itself, not the page
        var wrap = mainImages[index].parentElement;
        if (wrap) {
          wrap.scrollTo({ left: mainImages[index].offsetLeft - wrap.offsetLeft, behavior: userInitiated ? 'smooth' : 'instant' });
        }
      } else {
        // On desktop: toggle active class
        mainImages.forEach(function (el) { el.classList.remove('cpl__main-image--active'); });
        mainImages[index].classList.add('cpl__main-image--active');
      }

      thumbnails.forEach(function (el) { el.classList.remove('cpl__thumbnail--active'); });
      if (thumbnails[index]) {
        thumbnails[index].classList.add('cpl__thumbnail--active');
        // Scroll only the thumbnail strip horizontally, not the page
        var thumbStrip = thumbnails[index].parentElement;
        if (thumbStrip) {
          thumbStrip.scrollTo({ left: thumbnails[index].offsetLeft - thumbStrip.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(parseInt(thumb.dataset.imageIndex, 10), true);
      });
    });

    if (prevArrow) prevArrow.addEventListener('click', function () {
      showImage(currentImageIndex > 0 ? currentImageIndex - 1 : mainImages.length - 1, true);
    });

    if (nextArrow) nextArrow.addEventListener('click', function () {
      showImage(currentImageIndex < mainImages.length - 1 ? currentImageIndex + 1 : 0, true);
    });

    // Sync currentImageIndex on native scroll snap
    var mainImageWrap = section.querySelector('.cpl__main-image-wrap');
    if (mainImageWrap) {
      var scrollTimer;
      mainImageWrap.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var wrapLeft = mainImageWrap.scrollLeft;
          var wrapWidth = mainImageWrap.offsetWidth;
          var closest = Math.round(wrapLeft / wrapWidth);
          if (closest >= 0 && closest < mainImages.length && closest !== currentImageIndex) {
            currentImageIndex = closest;
            thumbnails.forEach(function (el) { el.classList.remove('cpl__thumbnail--active'); });
            if (thumbnails[closest]) thumbnails[closest].classList.add('cpl__thumbnail--active');
          }
        }, 100);
      }, { passive: true });
    }

    // =========================================
    // VARIANT SELECTION
    // =========================================
    section.querySelectorAll('.cpl__option-card, .cpl__option-pill, .cpl__size-card').forEach(function (el) {
      el.addEventListener('click', function () { handleOptionClick(el); });
    });

    function handleOptionClick(el) {
      var position = parseInt(el.dataset.optionPosition, 10);
      var value = el.dataset.optionValue;
      selectedOptions[position] = value;

      // Deactivate siblings with same position across ALL selector types in same option group
      var group = el.closest('.cpl__option-group');
      if (group) {
        group.querySelectorAll('[data-option-position="' + position + '"]').forEach(function (sibling) {
          sibling.classList.remove('cpl__option-card--active', 'cpl__option-pill--active', 'cpl__size-card--active');
          sibling.setAttribute('aria-pressed', 'false');
        });
      }

      // Activate clicked + matching siblings in other selector types
      if (group) {
        group.querySelectorAll('[data-option-value="' + value + '"][data-option-position="' + position + '"]').forEach(function (match) {
          if (match.classList.contains('cpl__option-card')) match.classList.add('cpl__option-card--active');
          if (match.classList.contains('cpl__option-pill')) match.classList.add('cpl__option-pill--active');
          if (match.classList.contains('cpl__size-card')) match.classList.add('cpl__size-card--active');
          match.setAttribute('aria-pressed', 'true');
        });
      }

      updateVariant();
    }

    function findVariant() {
      return variants.find(function (v) {
        return productData.options.every(function (optName, i) {
          return v.options[i] === selectedOptions[i + 1];
        });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;
      currentVariant = variant;

      var idInput = section.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      updateSellingPlan();
      updatePrices();

      // Show variant image
      if (variant.featured_image) {
        var matchingImage = -1;
        mainImages.forEach(function (img, idx) {
          if ((img.dataset.variantIds || '').indexOf(variant.id.toString()) !== -1) matchingImage = idx;
        });
        if (matchingImage >= 0) showImage(matchingImage);
      }

      // Update URL (preserve existing params, just update variant)
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      var btn = section.querySelector('.cpl__add-to-cart');
      if (btn) btn.disabled = !variant.available;

      updatePillMeta();
    }

    function getSellingPlanAllocation(variant) {
      if (!hasSellingPlans || !variant.selling_plan_allocations) return null;
      if (defaultSellingPlanId) {
        var match = variant.selling_plan_allocations.find(function (a) {
          return a.selling_plan_id === defaultSellingPlanId;
        });
        if (match) return match;
      }
      return variant.selling_plan_allocations[0] || null;
    }

    function updateSellingPlan() {
      var sellingPlanInput = section.querySelector('input[name="selling_plan"]');
      if (!sellingPlanInput) return;

      if (purchaseType === 'subscribe' && hasSellingPlans) {
        var allocation = getSellingPlanAllocation(currentVariant);
        if (allocation) sellingPlanInput.value = allocation.selling_plan_id;
      } else {
        sellingPlanInput.value = '';
      }
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
    }

    function updatePrices() {
      var allocation = getSellingPlanAllocation(currentVariant);
      var subscribePrice = allocation ? allocation.per_delivery_price : currentVariant.price;
      var comparePrice = currentVariant.price;

      // Subscribe price
      section.querySelectorAll('[data-subscribe-price]').forEach(function (el) { el.textContent = formatMoney(subscribePrice); });
      section.querySelectorAll('[data-subscribe-compare]').forEach(function (el) {
        el.textContent = subscribePrice < comparePrice ? formatMoney(comparePrice) : '';
        el.style.display = subscribePrice < comparePrice ? '' : 'none';
      });

      // One-time price
      section.querySelectorAll('[data-onetime-price]').forEach(function (el) { el.textContent = formatMoney(comparePrice); });

      // CTA price
      var atcPrice = purchaseType === 'subscribe' ? subscribePrice : comparePrice;
      section.querySelectorAll('[data-atc-price]').forEach(function (el) { el.textContent = formatMoney(atcPrice); });
      section.querySelectorAll('[data-atc-compare]').forEach(function (el) {
        if (purchaseType === 'subscribe' && subscribePrice < comparePrice) {
          el.textContent = formatMoney(comparePrice);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      // One-time link price
      section.querySelectorAll('[data-onetime-link-price]').forEach(function (el) { el.textContent = formatMoney(comparePrice); });

      // Per-meal amount
      var sizeOptionIndex = productData.options.length > 1 ? 1 : 0;
      var sizeValue = selectedOptions[sizeOptionIndex + 1] || '';
      var packMatch = sizeValue.match(/(\d+)/);
      var packCount = packMatch ? parseInt(packMatch[1], 10) : 1;
      var perMeal = subscribePrice / packCount;
      section.querySelectorAll('[data-per-meal-amount]').forEach(function (el) { el.textContent = formatMoney(perMeal); });

      updateSizeCardPrices();
      updateSubscriptionBenefitPack();
    }

    function updateSubscriptionBenefitPack() {
      var sizeOptionIndex = productData.options.length > 1 ? 1 : 0;
      var sizeValue = selectedOptions[sizeOptionIndex + 1] || '';
      var packMatch = sizeValue.match(/(\d+)/);
      if (!packMatch) return;
      var packSize = packMatch[1];

      section.querySelectorAll('[data-sub-benefit]').forEach(function (el) {
        var template = el.getAttribute('data-sub-benefit-template');
        if (!template) return;
        // Replace any number followed by -Pack (e.g. "18-Pack") with the selected size
        el.textContent = template.replace(/\d+-Pack/i, packSize + '-Pack');
      });
    }

    function updatePillMeta() {
      section.querySelectorAll('.cpl__pill-meta').forEach(function (el) {
        var optValue = el.dataset.pillMeta;
        if (!optValue) return;

        // Only show price/meal for options that contain a number (size options)
        var numMatch = optValue.match(/(\d+)/);
        if (!numMatch) return;
        var count = parseInt(numMatch[1], 10);
        if (count <= 0) return;

        var matchVariant = variants.find(function (v) {
          return v.options.some(function (o) { return o.toLowerCase().trim() === optValue; }) && v.available;
        });
        if (!matchVariant) return;

        var alloc = getSellingPlanAllocation(matchVariant);
        var price = alloc ? alloc.per_delivery_price : matchVariant.price;
        el.textContent = formatMoney(price / count) + '/meal';
      });
    }

    function updateSizeCardPrices() {
      section.querySelectorAll('.cpl__size-card').forEach(function (card) {
        var sizeValue = card.dataset.optionValue;
        var matchVariant = variants.find(function (v) {
          return v.options[0] === selectedOptions[1] && v.options[1] === sizeValue;
        });
        if (!matchVariant) return;

        var alloc = getSellingPlanAllocation(matchVariant);
        var sp = alloc ? alloc.per_delivery_price : matchVariant.price;
        var cp = matchVariant.price;
        var numMatch = sizeValue.match(/(\d+)/);
        var count = numMatch ? parseInt(numMatch[1], 10) : 1;

        var priceEl = card.querySelector('[data-size-value]');
        var compareEl = card.querySelector('[data-size-compare]');
        var perUnitEl = card.querySelector('[data-size-per-unit]');
        var perMealEl = card.querySelector('[data-size-per-meal]');

        if (priceEl) priceEl.textContent = formatMoney(sp);
        if (compareEl) {
          compareEl.textContent = sp < cp ? formatMoney(cp) : '';
          compareEl.style.display = sp < cp ? '' : 'none';
        }
        if (perUnitEl) perUnitEl.textContent = formatMoney(sp / count) + ' / pack';

        if (perMealEl) {
          perMealEl.innerHTML = 'Only <strong>' + formatMoney(sp / count) + '</strong> per meal';
        }
      });
    }

    // =========================================
    // PURCHASE TYPE TOGGLE
    // =========================================
    section.querySelectorAll('.cpl__purchase-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var type = opt.dataset.purchaseType;
        if (!type) return;
        purchaseType = type;

        section.querySelectorAll('.cpl__purchase-option').forEach(function (o) { o.classList.remove('cpl__purchase-option--active'); });
        opt.classList.add('cpl__purchase-option--active');

        updateSellingPlan();
        updatePrices();

        // Update CTA text for toggle mode
        var textEl = section.querySelector('[data-atc-text]');
        if (textEl) textEl.textContent = 'ADD TO CART';
      });
    });

    // V4 one-time link
    var onetimeLink = section.querySelector('[data-onetime-link]');
    if (onetimeLink) {
      onetimeLink.addEventListener('click', function (e) {
        e.preventDefault();
        purchaseType = 'onetime';
        updateSellingPlan();
        submitForm();
      });
    }

    // =========================================
    // FORM SUBMISSION (AJAX)
    // =========================================
    var form = section.querySelector('.cpl__form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submitForm(); });

    function submitForm() {
      var btn = section.querySelector('.cpl__add-to-cart');
      if (btn && btn.disabled) return;

      if (btn) { btn.classList.add('cpl__add-to-cart--loading'); btn.disabled = true; }

      var formData = {
        items: [{ id: parseInt(section.querySelector('input[name="id"]').value, 10), quantity: 1 }]
      };

      var sellingPlanInput = section.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        formData.items[0].selling_plan = parseInt(sellingPlanInput.value, 10);
      }

      formData.sections = ['cart-drawer', 'cart-icon-bubble'];
      formData.sections_url = window.location.pathname;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(formData),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            console.error('Cart error:', data.description);
            resetBtn();
            return;
          }

          if (typeof publish === 'function') {
            publish('cart-update', { source: 'custom-product-landing', productVariantId: formData.items[0].id, cartData: data });
          }

          openCartDrawer(data);
          resetBtn();

          // Reset to subscribe after one-time link purchase
          if (purchaseType === 'onetime' && getParam('purchase') !== 'toggle') {
            purchaseType = 'subscribe';
            updateSellingPlan();
          }
        })
        .catch(function (err) { console.error('Fetch error:', err); resetBtn(); });

      function resetBtn() {
        if (btn) { btn.classList.remove('cpl__add-to-cart--loading'); btn.disabled = !currentVariant.available; }
      }
    }

    function openCartDrawer(data) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      if (data.sections) {
        // Update cart drawer content
        if (data.sections['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
          var newEntries = doc.querySelector('#CartDrawer-Entries');
          var curEntries = document.querySelector('#CartDrawer-Entries');
          if (newEntries && curEntries) curEntries.innerHTML = newEntries.innerHTML;

          var newFooter = doc.querySelector('.cart-drawer__footer');
          var curFooter = document.querySelector('.cart-drawer__footer');
          if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;
        }

        // Update cart icon bubble
        if (data.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var bParser = new DOMParser();
            var bDoc = bParser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var newBubble = bDoc.querySelector('#cart-icon-bubble');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        }
      }

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    }

    // =========================================
    // INIT
    // =========================================
    updatePrices();
    updatePillMeta();

    // =========================================
    // SMOOTH FAQ ACCORDION
    // =========================================
    section.querySelectorAll('.cpl__faq').forEach(function (details) {
      var summary = details.querySelector('.cpl__faq-question');
      var answer = details.querySelector('.cpl__faq-answer');
      if (!summary || !answer) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.open) {
          // Closing: animate then remove open
          answer.style.gridTemplateRows = '0fr';
          answer.style.paddingBottom = '0';
          answer.addEventListener('transitionend', function handler() {
            details.open = false;
            answer.removeEventListener('transitionend', handler);
            answer.style.gridTemplateRows = '';
            answer.style.paddingBottom = '';
          });
        } else {
          // Opening: set open then CSS animates
          details.open = true;
        }
      });
    });
  }

  // =========================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // =========================================
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  });
})();
